/**
 * @generated SignedSource<<ee89ce35a5b91d10fd3e9014607a540b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SubscriptionState = "POST_SUBSCRIBED" | "POST_TRIAL" | "SUBSCRIBED" | "TRIAL";
import { FragmentRefs } from "relay-runtime";
export type UploadModal_RemainingUploadCredits_account$data = {
  readonly billingAccount: {
    readonly subscriptionBillingCycleAnchor: string | null;
    readonly subscriptionState: SubscriptionState;
  };
  readonly uploadCredits: {
    readonly includedCreditsUsedCurrentCycle: number;
    readonly includedUploadCredits: number;
  };
  readonly " $fragmentType": "UploadModal_RemainingUploadCredits_account";
};
export type UploadModal_RemainingUploadCredits_account$key = {
  readonly " $data"?: UploadModal_RemainingUploadCredits_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"UploadModal_RemainingUploadCredits_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UploadModal_RemainingUploadCredits_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingAccount",
      "kind": "LinkedField",
      "name": "billingAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscriptionState",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscriptionBillingCycleAnchor",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountUploadCredits",
      "kind": "LinkedField",
      "name": "uploadCredits",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includedUploadCredits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includedCreditsUsedCurrentCycle",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "66653cc0ff7e9461d43afb246b2ff333";

export default node;
